import { ILgpHeroSticky, LgpHeroSticky } from "@sky-it-livedata/livedata-sports-design-system";
import { graphql } from "appsync";

import transformQuery from "./transformers/query-transformer";
import transformSubscription from "./transformers/subscription-transformer";
import { LgpHeroStickyQuery, LgpHeroStickySubscription } from "./types";
import { log } from "../../utils/log";
import { useSubscription } from "../../hooks/useSubscription";
import { WidgetContext } from "../../types/WidgetContext";

export const setCustomAttributes = ({variables}: WidgetContext<LgpHeroStickyQuery>) => {
  return {
    variables: JSON.stringify(variables),
  };
}

const subscriptionDocument = graphql('subscription UpdateLgpHeroStickyWidget($gpId: ID!, $seasonAndCompId: ID!) {\n  onUpdateLgpHeroStickyBySeasonAndCompIdAndGpId(\n    gpId: $gpId\n    seasonAndCompId: $seasonAndCompId\n  ) {\n    gpId\n    seasonAndCompId\n    session {\n      label\n      name\n      status\n    }\n    info {\n      customGpName\n      endDate\n      flagImgUrl\n      startDate\n    }\n  }\n}');

export function getServerProps({
  props,
}: WidgetContext<LgpHeroStickyQuery>): ILgpHeroSticky {
  return transformQuery(props);
}

const LgpHeroStickyWidget = ({props,
  variables,
  ...rest
}: WidgetContext<ILgpHeroSticky>) => {
  log({ props, variables, ...rest });

  const updatedProps = useSubscription<
    ILgpHeroSticky,
    LgpHeroStickySubscription,
    typeof subscriptionDocument
  >({
    initialData: props,
    graphQLDocument: subscriptionDocument,
    variables,
    transform: transformSubscription,
    mergeData: false,
  }) as ILgpHeroSticky;

  return ( <LgpHeroSticky {...updatedProps} /> );
}

export default LgpHeroStickyWidget;